<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <section>
      <ValidationObserver 
        ref="form">
        <v-form>
          <div 
            class="title font-weight-bold black--text mb-6"
            style="opacity: 70%;">
            #Pakaian Sentana
          </div>

          <v-row
            style="min-height: 64.6vh;">
            <v-col 
              cols="12" 
              md="6"
              class="py-0">
              <ValidationProvider 
                name="ukuran_kaos" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Ukuran Kaos
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 15"
                  hide-details
                  clearable
                  @click:clear="form.ukuran_kaos = ''"

                  v-uppercase

                  v-model="form.ukuran_kaos"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ukuran Kaos {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ukuran_kaos !== '' && valid && form.ukuran_kaos !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="ukuran_blangkon" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Ukuran Blangkon
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 10"
                  hide-details
                  clearable
                  @click:clear="form.ukuran_blangkon = ''"

                  v-uppercase

                  v-model="form.ukuran_blangkon"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ukuran Blangkon {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ukuran_blangkon !== '' && valid && form.ukuran_blangkon !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="ukuran_selop" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Ukuran Selop
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 40"
                  hide-details
                  clearable
                  @click:clear="form.ukuran_selop = ''"

                  v-uppercase

                  v-model="form.ukuran_selop"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ukuran Selop {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ukuran_selop !== '' && valid && form.ukuran_selop !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="ukuran_pranakan" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Ukuran Pranakan
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 7"
                  hide-details
                  clearable
                  @click:clear="form.ukuran_pranakan = ''"

                  v-uppercase

                  v-model="form.ukuran_pranakan"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ukuran Pranakan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ukuran_pranakan !== '' && valid && form.ukuran_pranakan !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="ukuran_atela" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  Ukuran Atela
                  <!-- <span>
                    (boleh dikosongi)
                  </span> -->
                </div>
                
                <v-text-field
                  v-on:keyup.enter="save"
                  :style="`width: ${rps === 'xs' ? 100 : 40}%`"
                  class="mb-6"
                  filled
                  rounded
                  dense
                  :color="set_color"
                  placeholder="Contoh. 20"
                  hide-details
                  clearable
                  @click:clear="form.ukuran_atela = ''"

                  v-uppercase

                  v-model="form.ukuran_atela"
                  :success="valid"
                  :error-messages="errors"
                  required
                  style="border-radius: 10px">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Ukuran Atela {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.ukuran_atela !== '' && valid && form.ukuran_atela !== null">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-form>

        <div v-if="message.error.length > 0"
          class="text-center my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>
      </ValidationObserver>

      <div>
        <v-divider 
          class="mb-4" 
          style="border: 3px solid #f0f0f0; border-radius: 50px;"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()"
            color="green"
            elevation="0"
            class="body-2 font-weight-bold white--text text-capitalize"
            style="border-radius: 10px;">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>

            Simpan
          </v-btn>

          <router-link
            to="/sentana">
            <v-btn
              outlined
              class="body-2 font-weight-bold text-capitalize red--text px-2 ml-2"
              :disabled="process.form"
              style="border-radius: 10px;">
              <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>

              Batal
            </v-btn>
          </router-link>
        </v-card-actions>
      </div>
    </section>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          snackbar: false
        },
        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    mounted () {

    },
    methods: {
      async save () {
        this.message.error = ''
        
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let forms = Object.assign({}, this.form)
          forms.seksi = JSON.stringify(forms.seksi)
          
          await post(`admin/user/update`, {
            data: forms
          })
          .then((response) => {
            let res = response.data

            if (res.status === 200) {
              this.$emit('load', true)
                
              this.process.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
            } else {
              this.process.form = false
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>